<template>
  <div :class="$style.container">
    <div :class="$style.header">
      <h3 :class="$style.title">航行状态</h3>
    </div>
    <div :class="$style.body">
      <el-scrollbar :wrap-class="$style.scroller">
        <div :class="$style.checkboxGroup">
          <div :class="$style.checkboxItem" v-for="item in navistatus" :key="item.key">
            <el-checkbox v-model="state.navistatus" :label="item.key">{{ item.val }}</el-checkbox>
          </div>
        </div>
      </el-scrollbar>
    </div>

    <div :class="$style.footer">
      <button class="text-dark transition-colors hover:text-primary" @click="onReset"> <i class="el-icon-refresh-right" /> <span>重置</span></button>

      <div class="ml-auto">
        <el-button size="medium" @click="$emit('close')">取消</el-button>
        <el-button size="medium" type="primary" @click="onConfirm">确定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {
	defineComponent,
	useStore,
	computed,
	reactive,
  watch
} from "@nuxtjs/composition-api";

export default defineComponent({
	name: "IndexFilterType",
	props: {
		defaultData: {
			type: Object,
			default: () => ({ navistatus: [] })
		}
	},
	emits: ["confirm", "close"],
	setup(props, { emit }) {
		const store = useStore();
		const navistatus = computed(() => {
			return store.state.cruiseMap.filterData.navistatus;
		});
		function onReset() {
			state.navistatus = [];
		}
		const state = reactive({
			navistatus: []
		});

		watch(
			() => props.defaultData.navistatus,
			(value = []) => {
				state.navistatus = [...value];
			},
			{
				immediate: true
			}
		);
		// const checkedNavistatus = ref([]);

		function onConfirm() {
			emit("confirm", { ...state });
		}
		return {
			onReset,
			navistatus,
			state,

			onConfirm
		};
	}
});
</script>
<style lang="scss" module>
.container {
  padding: 1.5rem;
}
.header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.title {
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.body {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
  overflow: hidden;
}
.footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  padding-top: 0.625rem;
}
.scroller {
  max-height: 23rem;
}
.checkboxGroup {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-top: 1.875rem;
}
.checkboxItem {
  flex-basis: 33.333333%;
  margin-bottom: 2.75rem;
}
</style>